<template>
  <a
    v-if="visible"
    class="tooltip"
    :data-tooltip="
      showTooltip
        ? `Tests: ${item.chocoPackage.PackageTestResultStatus}`
        : false
    "
    :href="
      item.chocoPackage.PackageTestResultUrl !== ''
        ? item.chocoPackage.PackageTestResultUrl
        : item.chocoPackage.GalleryDetailsUrl
    "
    target="_blank"
  >
    <slot></slot>
  </a>
</template>

<script>
import checks from "@/utils/packageCheck";

export default {
  props: { item: Object, showTooltip: Boolean },
  computed: {
    visible() {
      return checks.hasFailedTests(this.item);
    }
  }
};
</script>
